import { useMemo } from 'react';
import styled, { useTheme } from '../themes/themed-styled-components';
import DataTableComponent, { IDataTableProps, TableStyles } from 'react-data-table-component'
import { defaultsDeep } from 'lodash';

export const DataTableContainer = styled.div<{ fixedHeader: boolean, lastColumnSticky: boolean }>`
    height: 100%;
    width: 100%;
    
    /*display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: auto 1fr;
    grid-template-areas: 
        'header'
        'table';*/

    & > div {
        height: 100%;
        max-width: 100%;
        overflow: auto;
    }

    & .rdt_Table {  
      /* grid container settings 
      display: grid;
      grid-template-columns: 1fr;
      grid-template-rows: auto 1fr;
      grid-template-areas: 
        'head'
        'body';*/
    }

    ${({ fixedHeader }) => fixedHeader ? `& .rdt_TableHead {
        position: sticky;
        top: 0;
        z-index: 200
    }`: null}

    & .rdt_TableBody {
        /*grid-area: body;
        overflow-x: hidden;
        overflow-y: auto;*/
    }

    & .rdt_TableCell {
        padding-top: 1em;
        padding-bottom: 1em;
    }

    & .rdt_TableCell:only-child {
        padding-right: 32px;
    }

    ${({ lastColumnSticky }) => lastColumnSticky ? `
        & .rdt_TableCol:last-child,
        & .rdt_TableCell:last-child {
            position: sticky;
            right: 0;
            background-color: inherit;
    }` : null}
    
`;


const DataTable = <T,>({ customStyles, fixedHeader, lastColumnSticky, ...rest }: IDataTableProps<T> & { lastColumnSticky?: boolean }) => {
    //console.log(scroll);
    const theme = useTheme();

    const styles = useMemo<TableStyles>(() => defaultsDeep(customStyles, {
        table: {

            style: {
                backgroundColor: theme.bodyBg
            },
        },
        tableWrapper: {
            style: {
                //gridArea: 'table',
                //display: 'block',
                height: '100%',
            },
        },
        header: {
            style: {
                //fontSize: '22px',
                //color: theme.text.primary,
                //backgroundColor: theme.background.default,
                //minHeight: '56px',
                //paddingLeft: '16px',
                //paddingRight: '8px',
            },
        },
        //subHeader: {
        //    style: {
        //        backgroundColor: theme.background.default,
        //        minHeight: '52px',
        //    },
        //},
        //head: {
        //    style: {
        //        position: 'sticky',
        //        top: 0,
        //        zIndex: 200
        //    },
        //},
        //headRow: {
        //    style: {
        //        backgroundColor: theme.background.default,
        //        minHeight: '56px',
        //        borderBottomWidth: '1px',
        //        borderBottomColor: theme.divider.default,
        //        borderBottomStyle: 'solid',
        //    },
        //    denseStyle: {
        //        minHeight: '32px',
        //    },
        //},
        headCells: {
            style: {
                //        fontSize: '12px',
                //        fontWeight: 500,
                //        color: theme.text.primary,
                //        paddingLeft: '16px',
                //        paddingRight: '16px',
                textAlign: 'center',
                overflowX: 'hidden'
            },
            //    activeSortStyle: {
            //        color: theme.text.primary,
            //        '&:focus': {
            //            outline: 'none',
            //        },
            //        '&:hover:not(:focus)': {
            //            color: theme.sortFocus.default,
            //        },
            //    },
            //    inactiveSortStyle: {
            //        '&:focus': {
            //            outline: 'none',
            //            color: theme.sortFocus.default,
            //        },
            //        '&:hover': {
            //            color: theme.sortFocus.default,
            //        },
            //    },
        },
        //contextMenu: {
        //    style: {
        //        backgroundColor: theme.context.background,
        //        fontSize: '18px',
        //        fontWeight: 400,
        //        color: theme.context.text,
        //        paddingLeft: '16px',
        //        paddingRight: '8px',
        //        transform: 'translate3d(0, -100%, 0)',
        //        transitionDuration: '125ms',
        //        transitionTimingFunction: 'cubic-bezier(0, 0, 0.2, 1)',
        //        willChange: 'transform',
        //    },
        //    activeStyle: {
        //        transform: 'translate3d(0, 0, 0)',
        //    },
        //},
        cells: {
            //    style: {
            //        paddingLeft: '16px',
            //        paddingRight: '16px',
            //        wordBreak: 'break-word',
        },
        //},
        rows: {
            style: {
                //        fontSize: '13px',
                //        color: theme.text.primary,
                //        backgroundColor: theme.background.default,
                minHeight: 'auto',
                //        '&:not(:last-of-type)': {
                //            borderBottomStyle: 'solid',
                //            borderBottomWidth: '1px',
                //            borderBottomColor: theme.divider.default,
                //        },
            },
            //    denseStyle: {
            //        minHeight: '32px',
            //    },
            //    selectedHighlightStyle: {
            //        // use nth-of-type(n) to override other nth selectors
            //        '&:nth-of-type(n)': {
            //            color: theme.selected.text,
            //            backgroundColor: theme.selected.default,
            //            borderBottomColor: theme.background.default,
            //        },
            //    },
            //    highlightOnHoverStyle: {
            //        color: theme.highlightOnHover.text,
            //        backgroundColor: theme.highlightOnHover.default,
            //        transitionDuration: '0.15s',
            //        transitionProperty: 'background-color',
            //        borderBottomColor: theme.background.default,
            //        outlineStyle: 'solid',
            //        outlineWidth: '1px',
            //        outlineColor: theme.background.default,
            //    },
            //    stripedStyle: {
            //        color: theme.striped.text,
            //        backgroundColor: theme.striped.default,
            //    },
        },
        //expanderRow: {
        //    style: {
        //        color: theme.text.primary,
        //        backgroundColor: theme.background.default,
        //    },
        //},
        //expanderCell: {
        //    style: {
        //        flex: '0 0 48px',
        //    },
        //},
        //expanderButton: {
        //    style: {
        //        color: theme.button.default,
        //        fill: theme.button.default,
        //        backgroundColor: 'transparent',
        //        borderRadius: '2px',
        //        transition: '0.25s',
        //        height: '100%',
        //        width: '100%',
        //        '&:hover:enabled': {
        //            cursor: 'pointer',
        //        },
        //        '&:disabled': {
        //            color: theme.button.disabled,
        //        },
        //        '&:hover:not(:disabled)': {
        //            cursor: 'pointer',
        //            backgroundColor: theme.button.hover,
        //        },
        //        '&:focus': {
        //            outline: 'none',
        //            backgroundColor: theme.button.focus,
        //        },
        //        svg: {
        //            margin: 'auto',
        //        },
        //    },
        //},
        //pagination: {
        //    style: {
        //        color: theme.text.secondary,
        //        fontSize: '13px',
        //        minHeight: '56px',
        //        backgroundColor: theme.background.default,
        //        borderTopStyle: 'solid',
        //        borderTopWidth: '1px',
        //        borderTopColor: theme.divider.default,
        //    },
        //    pageButtonsStyle: {
        //        borderRadius: '50%',
        //        height: '40px',
        //        width: '40px',
        //        padding: '8px',
        //        margin: 'px',
        //        cursor: 'pointer',
        //        transition: '0.4s',
        //        color: theme.button.default,
        //        fill: theme.button.default,
        //        backgroundColor: 'transparent',
        //        '&:disabled': {
        //            cursor: 'unset',
        //            color: theme.button.disabled,
        //            fill: theme.button.disabled,
        //        },
        //        '&:hover:not(:disabled)': {
        //            backgroundColor: theme.button.hover,
        //        },
        //        '&:focus': {
        //            outline: 'none',
        //            backgroundColor: theme.button.focus,
        //        },
        //    },
        //},
        //noData: {
        //    style: {
        //        display: 'flex',
        //        alignItems: 'center',
        //        justifyContent: 'center',
        //        color: theme.text.primary,
        //        backgroundColor: theme.background.default,
        //    },
        //},
        //progress: {
        //    style: {
        //        display: 'flex',
        //        alignItems: 'center',
        //        justifyContent: 'center',
        //        color: theme.text.primary,
        //        backgroundColor: theme.background.default,
        //    },
        //},
    }), [theme, customStyles]);

    //const datatableContainer = createRef<HTMLDivElement>();

    //useEffect(() => {
    //    const table = (nth(datatableContainer?.current?.getElementsByClassName('rdt_Table'), 0) as HTMLElement) ?? null;
    //    const tableHead = (nth(datatableContainer?.current?.getElementsByClassName('rdt_TableHead'), 0) as HTMLElement) ?? null;


    //    console.log({table,tableHead});

    //    if (table !== null && tableHead !== null) {
    //        const setHeaderTranslateY = () => {
    //            tableHead.style.transform = `translateY(${table.scrollTop}px)`;
    //            console.log(table.scrollTop);
    //        };

    //        table.addEventListener('scroll', setHeaderTranslateY);

    //        return () => {
    //            table.removeEventListener('scroll', setHeaderTranslateY);
    //        }
    //    }
    //}, []);

    //useEffect(() => {
    //    const tbody = tableBody;

    //    if ((tbody?.scrollTop ?? 0) === 0) {
    //        tableBody?.scrollTo(tableBody.scrollLeft, scroll);
    //    }

    //}, [tableBody]);

    //const debouncedSetTableBodyScrollTop = useMemo(() => debounce(setScroll, 100), [setScroll]);

    //const onScroll = (event: React.UIEvent<HTMLDivElement, UIEvent>) => {
    //    const scrollTop = (event.target as HTMLElement)?.scrollTop;
    //    dispatch({type: 'setScroll', scroll: scrollTop});
    //};

    return <DataTableContainer fixedHeader lastColumnSticky={lastColumnSticky ?? false}>
        <DataTableComponent<T> {...rest} customStyles={styles} />
    </DataTableContainer>;
}

export default DataTable;